<template>
  <el-dialog :visible.sync="show" title="新增报单" width="600px">
    <div class="tabs flex-row">
      <span
        v-for="(item, index) in tabs"
        :key="index"
        class="item"
        :class="{ active: curTab == index }"
        @click="curTab = index"
        >{{ item }}</span
      >
    </div>
    <div class="content" v-if="curTab === 0">
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <!-- <el-form-item
          label="报单ID："
          prop="calculationFormId" -->
        <el-form-item
          label="报单ID："
          prop="productId"
          :rules="[
            { required: true, message: '请填写报单ID', trigger: 'blur' },
          ]"
        >
          <el-input v-model="form.productId" placeholder="请填写报单ID">
            <img
              slot="prefix"
              v-if="errorPlatformCode === 'PLATFORM_5'"
              src="../../../../assets/images/tb.png"
              class="platform-logo"
            />
            <img
              slot="prefix"
              v-if="errorPlatformCode === 'PLATFORM_6'"
              src="../../../../assets/images/dy.png"
              class="platform-logo"
            />
          </el-input>
        </el-form-item>
        <el-form-item
          label="订单号："
          prop="thirdOrderSn"
          :rules="[
            { required: true, message: '请填写订单编号', trigger: 'blur' },
          ]"
        >
          <el-input
            type="textarea"
            placeholder="请输入订单编号，多个换行，1次最多50行"
            :rows="5"
            @input="handleInput"
            ref="inputValueRef"
            v-model="form.thirdOrderSn"
          ></el-input>
        </el-form-item>
        <!-- :rules="[{ required: true, message: '请填写订单件数', trigger: 'blur' }]" -->
        <el-form-item label="订单件数：" prop="orderNumber">
          <el-input
            v-model="form.orderNumber"
            @input="orderNumberInput"
            placeholder="请填写订单件数"
          ></el-input>
        </el-form-item>
        <!-- :rules="[{ required: true, message: '请填写订单金额', trigger: 'blur' }]" -->
        <el-form-item label="订单金额：" prop="orderAmount">
          <el-input
            v-model="form.orderAmount"
            @input="amountInput"
            placeholder="请填写订单金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道备注：">
          <el-input
            v-model="form.qdRemark"
            placeholder="请填写渠道备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单截图：">
          <div class="upload-images-wrap">
            <div class="images">
              <ui-upload
                class="item"
                v-if="orderScreenshot.length < 3"
                fileType="image"
                style="display: inline-block"
                maxTip="(最多3张)"
                @submit="uploadCallback"
              />
              <div
                class="item"
                v-for="(item, index) in orderScreenshot"
                :key="index"
              >
                <el-image
                  class="img"
                  :src="item"
                  :preview-src-list="orderScreenshot"
                ></el-image>
                <i
                  class="el-icon-circle-close close"
                  @click="delImage(index)"
                ></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="tip">
        <div class="title">用户须知</div>
        <div class="content">
          <div>1. 请将平台订单号复制后，填入上方文本框后，点击上报订单</div>
          <div>2. 建议一次上报一个订单号，若需上报多个请将订单号换行</div>
          <div class="red" style="font-weight: 600">
            3. 订单号上报完成后，查询上报结果有一定的延迟，请耐心等待
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="curTab == 1">
      <div style="padding-bottom: 12px">
        <el-button type="text" @click="downloadTemp">导入模版</el-button>
      </div>
      <div class="upload-wrap">
        <el-upload
          class="upload-demo"
          drag
          accept=".xls, .xlsx"
          :limit="1"
          :auto-upload="false"
          :file-list="fileList"
          :on-change="handleUploadChange"
          :on-remove="() => (fileList = [])"
          ref="upload"
          action="#"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">点击或拖拽上传文件</div>
          <div class="el-upload__tip" slot="tip">
            请先下载导入模版，填入数据后，再进行订单上传 <br />
            数量1，大小2M以内，支持格式xls,xlsx
          </div>
        </el-upload>
      </div>
    </div>

    <div slot="footer">
      <el-button size="mini" @click="$emit('close')">关闭</el-button>
      <el-button size="mini" v-if="curTab === 0" @click="submit" type="primary"
        >上报订单</el-button
      >
      <el-button
        size="mini"
        v-if="curTab === 1"
        :disabled="!fileList.length"
        @click="submitUpload"
        type="primary"
        >上传</el-button
      >
    </div>

    <el-dialog
      v-if="showSubmitResultDialog"
      :visible.sync="showSubmitResultDialog"
      append-to-body
      title="上报结果"
      width="410px"
    >
      <div class="content">
        <!-- 总上报{{ submitResult['总共订单数'] || 0 }}，查询中{{ submitResult['无效订单数'] || 0 }}，已跟单{{ submitResult['有效订单数'] || 0 }}，已丢单0，重复{{ submitResult['重复订单号'].length }} -->
        总上报 <span class="num">{{ submitResult["总上报"] || 0 }}</span
        >， 查询中 <span class="num">{{ submitResult["查询中"] || 0 }}</span
        >， 已跟单 <span class="num">{{ submitResult["已跟单"] || 0 }}</span
        >， 已丢单 <span class="num">{{ submitResult["已丢单"] || 0 }}</span
        >， 自己重复报单
        <span class="num">{{ submitResult["自己重复报单"] || 0 }}</span
        >， 已被他人重复报单
        <span class="num">{{ submitResult["已被他人重复报单"] || 0 }}</span
        >， 已被认领
        <span class="num">{{ submitResult["已被认领"] || 0 }}</span>
        <div
          style="padding: 12px 0"
          v-if="
            submitResult['自己重复报单订单号列表'].length ||
            submitResult['已被他人重复报单订单号列表'].length ||
            submitResult['已被认领订单号'].length
          "
        >
          <h3>上报失败单号</h3>
          <div v-if="submitResult['自己重复报单订单号列表'].length">
            自己重复报单{{ submitResult["自己重复报单订单号列表"].length }}:
            {{ submitResult["自己重复报单订单号列表"].join(", ") }}
          </div>
          <div v-if="submitResult['已被他人重复报单订单号列表'].length">
            已被他人重复报单{{
              submitResult["已被他人重复报单订单号列表"].length
            }}: {{ submitResult["已被他人重复报单订单号列表"].join(", ") }}
          </div>
          <div v-if="submitResult['已被认领订单号'].length">
            已被认领{{ submitResult["已被认领订单号"].length }}:
            {{ submitResult["已被认领订单号"].join(", ") }}
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="submitConfirm" type="primary"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-if="showErrorDialog"
      :visible.sync="showErrorDialog"
      append-to-body
      title="提示"
      width="410px"
    >
      <div class="content" v-html="errorMessage"></div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="showErrorDialog = false"
          >去修改</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-if="showValidateErrorDialog"
      :visible.sync="showValidateErrorDialog"
      append-to-body
      title="提示"
      width="410px"
    >
      <div class="content">
        表格上传失败，请导出查看失败原因，修改后再进行上传
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="exportValidateErrorData"
          >导出</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getUserId } from "@/utils/getUser";
import { uploadImage } from "@/service/apis/common";
import {
  supUploadOrder,
  validateImportSupOrderReportByForm,
  addSupOrderReportByFormWeb,
  checkThirdOrderSn,
} from "@/service/apis/order";
import { douyinM2SPageList } from "@/service/apis/group";
import { formatNumber } from "@/utils/util";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
const errorMap = {
  PLATFORM_5: "非18或19位纯数字",
  PLATFORM_6: "非19位纯数字",
};

export default {
  name: "addReportDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    roleType: {
      type: Number,
      default: null,
    },
    reportType: {
      type: String,
      default: "",
    },
    product: {
      type: Object,
      default: null,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      orderScreenshot: [],
      curTab: 0,
      showSubmitResultDialog: false,
      submitResult: {},
      showErrorDialog: false,
      errorMessage: "",
      errorPlatformCode: "",
      tabs: ["手动录入", "表格导入"],
      form: {
        productId: "",
        thirdOrderSn: "",
        orderNumber: "",
        orderAmount: "",
        qdRemark: "",
      },
      groupList1: [],
      groupList2: [],
      showRstDialog: false,
      fileList: [],
      showValidateErrorDialog: false,
      validateErrorData: [],
    };
  },
  watch: {
    roleType: {
      handler() {
        this.getAccountList();
      },
      immediate: true,
    },
    show: {
      handler(val) {
        if (val) {
          if (this.product && this.product.productId) {
            this.form.productId = this.product.productId;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    delImage(index) {
      this.orderScreenshot.splice(index, 1);
    },
    // 导入
    uploadCallback(file) {
      if (this.orderScreenshot.length >= 3) {
        this.$message.warning("最多上传3张图片");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "图片上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.45)",
      });

      const formData = new FormData();
      formData.append("media", file);
      uploadImage
        .call(this, formData)
        .then((resp) => {
          this.orderScreenshot.push(resp.img);
        })
        .finally(() => {
          loading.close();
        });
    },
    orderNumberInput(val) {
      this.$nextTick(() => {
        this.form.orderNumber = formatNumber(val, 0);
      });
    },
    amountInput(val) {
      //
    },
    handleInput(value) {
      this.$nextTick(() => {
        this.form.thirdOrderSn = value.replace(/[^\S\n]+/g, "");
      });
    },
    downloadTemp() {
      window.open(location.origin + "/template/SupOrderTemplate.xlsx");
    },
    handleUploadChange(file) {
      this.fileList = [file];
    },
    submitUpload() {
      this.handleUpload();
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false;

        this.form.thirdOrderSn = this.form.thirdOrderSn.replace(
          /非18或19位纯数字|非19位纯数字|订单错误/g,
          ""
        );
        let opt = JSON.parse(JSON.stringify(this.form));
        const list = opt.thirdOrderSn.split("\n").filter((item) => !!item);
        opt.thirdOrderSnList = [...new Set(list)];
        if (!opt.thirdOrderSnList.length) {
          this.$message.error("请输入正确的订单号");
          return false;
        }
        delete opt.thirdOrderSn;
        // 截图
        opt.orderScreenshot = this.orderScreenshot.join(",");
        console.log(opt);
        const checkRes = await checkThirdOrderSn.call(this, opt.thirdOrderSnList)
        // 独家爆品
        if (checkRes && checkRes.douyinM2s && checkRes.douyinM2s.length) {
          checkRes.douyinM2s.forEach((item) => {
            this.form.thirdOrderSn = this.form.thirdOrderSn.replace(item, item + ' 抖音高佣订单');
          })
          this.errorMessage = `<span class="red">标记订单号</span>是其他业务类型订单，<span class="red">请删除后</span>再进行上报，标记订单号请从相应报单入口上报`
          this.showErrorDialog = true;
          return false;
        }
        addSupOrderReportByFormWeb
          .call(this, opt, false)
          .then((res) => {
            console.log('res:', res);
            if (res) {
              this.submitResult = res;
              this.errorPlatformCode = "";
              this.showSubmitResultDialog = true;
            }
          })
          .catch((error) => {
            const { errMsg, data } = error;
            console.log('errMsg:', error);
            console.log('data:', data);
            if (data) {
              this.errorPlatformCode = data.platformCode || "";
              const invalidOrderSns = data.invalidOrderSns || [];
              if (invalidOrderSns.length) {
                invalidOrderSns.forEach((item) => {
                  if (this.form.thirdOrderSn.includes(item)) {
                    this.form.thirdOrderSn = this.form.thirdOrderSn.replace(
                      item,
                      item + errorMap[this.errorPlatformCode] || "订单错误"
                    );
                  }
                });
              }
            }
            this.errorMessage = errMsg || error || "报单录入失败";
            this.showErrorDialog = true;
          });
      });
    },
    submitConfirm() {
      // this.form.calculationFormId = "";
      this.form.productId = "";
      this.form.thirdOrderSn = "";
      this.form.orderNumber = "";
      this.form.orderAmount = "";
      this.form.qdRemark = "";

      this.orderScreenshot = [];
      this.showSubmitResultDialog = false;
      this.$refs.form.resetFields();
      this.$emit("refresh-list");
    },
    closeRstDialog() {
      this.showRstDialog = false;
    },
    getAccountList(parentId) {
      // 超管 - 查看所有一级 1
      if (this.roleType == 1) {
        // one=1 就是 一渠道
        // 0就是二级
        douyinM2SPageList
          .call(this, {
            one: 1,
            current: 1,
            size: 1000,
          })
          .then((res) => {
            this.groupList1 = res.records || [];
          });
      }
      // 一级 查看二级列表
      if (this.roleType == 3 || parentId) {
        let opt = {
          one: 0, // 二级
          current: 1,
          size: 1000,
          parentId: getUserId(),
        };
        if (parentId) {
          opt.parentId = parentId;
        }
        douyinM2SPageList.call(this, opt).then((res) => {
          this.groupList2 = res.records || [];
        });
      }
    },
    // 上传excel
    handleUpload() {
      if (!this.fileList.length) return;
      const file = this.fileList[0];
      const { size } = file;
      if (size / 1024 / 1024 > 2) {
        this.$message.error("上传文件的大小不能超过2MB");
        this.fileList = [];
        return false;
      }
      const opt = {};

      if (this.reportType) {
        opt.reportType = this.reportType;
      }

      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.45)",
      });
      try {
        // 先校验文件
        validateImportSupOrderReportByForm
          .call(this, file.raw, opt)
          .then((res) => {
            if (res && res.length && res.some((item) => item.errorMsg)) {
              // 验证失败，显示弹框
              this.validateErrorData = res;
              this.showValidateErrorDialog = true;
              this.fileList = [];
            } else {
              supUploadOrder
                .call(this, file.raw, opt)
                .then((resp) => {
                  if (resp) {
                    // 清空选择文件
                    this.fileList = [];
                    // this.$message.success('导入成功')
                    this.$emit("on-success", resp);
                  }
                })
                .finally(() => {
                  loading.close();
                });
            }
          })
          .finally(() => {
            loading.close();
          });
      } catch (e) {
        this.fileList = [];
        console.error(e);
        loading.close();
      }
    },
    // 导出验证失败数据
    exportValidateErrorData() {
      if (!this.validateErrorData.length) return;

      // 准备表头
      const heads = [
        "报单ID",
        "订单编号",
        "订单件数",
        "订单金额",
        "渠道备注",
        "失败原因",
      ];
      const data = [heads];

      // 准备数据
      this.validateErrorData.forEach((item) => {
        data.push([
          // { t: 's', v: item.calculationFormId || "" }, // 以文本形式导出报单ID
          { t: 's', v: item.productId || "" }, // 以文本形式导出产品编号
          item.thirdOrderSn || "",
          item.orderNumber || "",
          item.orderAmount || "",
          item.qdRemark || "",
          item.errorMsg || "",
        ]);
      });

      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(dataBlob, `验证失败数据 ${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
      this.showValidateErrorDialog = false;
      this.fileList = [];
    },
  },
};
</script>

<style scoped>
.content {
  padding-top: 12px;
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.flex-row {
  line-height: 30px;
}
.upload-wrap {
  padding-top: 16px;
}
.tabs {
  padding-left: 0;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
}
.tip {
  padding: 16px 0 0 0;
  color: #666;
  font-size: 13px;
}
.tip .content {
  color: #666;
  padding-top: 4px;
  line-height: 20px;
}
.tip .title {
  padding-bottom: 5px;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(34, 34, 34, 1);
}
.num {
  font-weight: 600;
  font-size: 16px;
}
::v-deep .upload {
  width: 100px;
  height: 100px;
  font-size: 12px;
}
::v-deep .upload img {
  width: 60%;
  height: auto;
}
.upload-images-wrap {
  display: flex;
  align-items: top;
}
.images {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}
.images .item {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  position: relative;
  margin-right: 6px;
  margin-bottom: 10px;
}
.images .item .close {
  position: absolute;
  right: -4px;
  top: -4px;
  cursor: pointer;
}
.images .item .img {
  width: 100%;
  height: 100%;
}
.platform-logo {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
::v-deep .el-input__prefix {
  line-height: 28px;
}
</style>
